import { render, staticRenderFns } from "./VDropdown.vue?vue&type=template&id=88a40040&"
import script from "./VDropdown.vue?vue&type=script&lang=js&"
export * from "./VDropdown.vue?vue&type=script&lang=js&"
import style0 from "./VDropdown.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp7.4.1\\htdocs\\e2e-invoicing\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88a40040')) {
      api.createRecord('88a40040', component.options)
    } else {
      api.reload('88a40040', component.options)
    }
    module.hot.accept("./VDropdown.vue?vue&type=template&id=88a40040&", function () {
      api.rerender('88a40040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/dropdown/VDropdown.vue"
export default component.exports